
/**
 * 사용자별 수강 등록에 대한 코스 종합 AI 피드백 (수강생이고 피드백 존재 시 반환)
 * @nullable
 */
export type GetCourseDetail200AiFeedback = { [key: string]: unknown } | null;
